export default {
      id: "i-bpif-v-usage",
      viewBox: "0 0 35 46",
      url: __webpack_public_path__ + "img/sprite.svg#i-bpif-v",
      toString: function () {
        return this.url;
      }
    }